import script from "./AdminAvisos.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminAvisos.vue?vue&type=script&setup=true&lang=js"

import "./AdminAvisos.vue?vue&type=style&index=0&id=13878a42&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13878a42"]])

export default __exports__